export default __webpack_public_path__ + "static/media/011-shovel.e09ca851.svg";